import React from 'react';
import Tooltip from 'components/Tooltip';
import { ReportProblem } from '@mui/icons-material';

// Column With Urgent Message Icon
export const fullNameColumnWithIcon = (fieldName = 'FullName', headerName = 'FullName') => {
  const column = {
    field: fieldName,
    headerName,
    renderCell: (params) => {
      const { value, row } = params;
      if (!value) return null;
      return (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          {/* Display Icon with Tooltip */}
          {UrgentMessageIcon(row)}

          {/* Column Name */}
          <span>{value}</span>
        </div>
      );
    },
  };

  return column;
};

// Display Urgent Message Icon
export const UrgentMessageIcon = (row) => {
  const showUrgentIcon = row?.hasAnyUrgentMessage && !row?.ActiveWarrant;
  const hasActiveBulletin = row?.activeBulletinCount > 0;
  const hasActiveSop = row?.sopCount > 0;

  const tooltipContent = (
    <div>
      {hasActiveSop && <div>SOPs: {row.sopCount}</div>}
      {hasActiveBulletin && <div>Active Bulletins: {row.activeBulletinCount}</div>}
    </div>
  );

  return (
    showUrgentIcon &&
    (hasActiveBulletin || hasActiveSop) && (
      <Tooltip title={tooltipContent}>
        <span style={{ display: 'inline-flex' }}>
          <ReportProblem sx={{ fontSize: 24, color: 'orange', padding: '2px' }} />
        </span>
      </Tooltip>
    )
  );
};
